import { Address } from 'viem';

import {
  FLIPIT_NODE_ADDRESS,
  HELIX_NODE_ADDRESS,
  MAGNETO_NODE_ADDRESS,
  MEER_NODE_ADDRESS,
  NEMESIS_NODE_ADDRESS,
  VALLEY_NODE_ADDRESS,
} from '@/global/configs/common.config';

export interface NodeInventory {
  address: Address;
  name: string;
  image?: string;
}

export const NODE_INVENTORIES_V1: NodeInventory[] = [
  {
    address: FLIPIT_NODE_ADDRESS,
    name: 'Flipit Node',
    image: 'https://d34zw29r4frl0n.cloudfront.net/flipit/flipit.png',
  },
  {
    address: MAGNETO_NODE_ADDRESS,
    name: 'MagnetoHR Node',
    image: 'https://d34zw29r4frl0n.cloudfront.net/magneto/magneto.webp',
  },
  {
    address: NEMESIS_NODE_ADDRESS,
    name: 'Nemesis Node',
    image: 'https://d34zw29r4frl0n.cloudfront.net/nemesis/nemesis.webp',
  },
  {
    address: VALLEY_NODE_ADDRESS,
    name: 'Valley Node',
    image: 'https://d34zw29r4frl0n.cloudfront.net/valley/valley.gif',
  },
  {
    address: MEER_NODE_ADDRESS,
    name: 'Meer Node',
    image: 'https://d34zw29r4frl0n.cloudfront.net/meer/meer.gif',
  },
  {
    address: HELIX_NODE_ADDRESS,
    name: 'Helix Node',
    image:
      'https://d34zw29r4frl0n.cloudfront.net/public/wallets/0xc5becb81dc1e5f36ee1bba79fa86f1c66fc49f96/helix-node/helix.webp',
  },
];

export const NODE_INVENTORIES_V2: NodeInventory[] = [
  // mock data
  {
    address: '0x49668a0b91959952d41da547a19fa015966fda0f',
    name: 'MagnetoHR Node',
    image: 'https://d34zw29r4frl0n.cloudfront.net/magneto/magneto.webp',
  },
];
